import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "../components/InputWrapper";
import ButtonWrapper from "../components/ButtonWrapper";
import SelectWrapper from "../components/SelectWrapper";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import MainWrapper from "../components/MainWrapper";
import WarningModal from "../components/WarningModal";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import getVerifyManualTransaction from "../redux/actions/getVerifyManualTransaction";
import LanugageSelector from "../components/LanugageSelector";
import { CloseCircleOutlined, EditOutlined } from "@ant-design/icons";
import { Divider } from "antd";

const CardWrapper = styled(Slide)`
  height: auto;
  z-index: 999;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 35%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  // border-bottom-left-radius: 10px;
  // border-bottom-right-radius: 10px;
  overflow: hidden;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
  .warning-text {
    font-size: 25px !important;
    font-weight: bold;
    color: #b8321f;
  }
`;

const ConfirmationAndWarningTrueMoney = (props) => {
  const params = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let {
    qrManualTransactionParams: {
      accountNumber,
      amount,
      bankCode,
      bankName,
      qrCodeTransactionId,
      sessionId,
      type,
      userId,
    },
  } = state;
  const [bankNameLang, setBankNameLang] = useState(bankName);

  const { lang } = useSelector((state) => state.languageSelectorReducer);
  const { isLoading } = useSelector((state) => state.postQrInitManualReducer);

  // -----checking link is verify or not---------
  const { error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  useEffect(() => {
    dispatch(getVerifyManualTransaction(params.id));
  }, []);

  useEffect(() => {
    if (error) {
      navigate(`/${params.id}`);
    }
  }, [error]);

  const acceptWarningHandle = () => {
    dispatch(
      postQrInitManualTransaction(
        state.qrManualTransactionParams,
        navigate,
        params.id
      )
    );
  };

  useEffect(() => {
    let findBankName = bankNames.find((item) => item.bankNameEng == bankName);
    lang == "en"
      ? setBankNameLang(findBankName.bankNameEng)
      : setBankNameLang(findBankName.bankNameThai);
  }, [lang]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <MainWrapper>
        <CardWrapper className="">
          <div className="w-100 p-4">
            <div className="d-flex justify-content-between">
              <p className="label fw-bold mb-0">
                {language[lang].trnxInfoCard.PAYER_BANK_DETAILS}
              </p>
              <LanugageSelector />
            </div>
            <p
              className="label text-center lh-sm mb-0 mt-4"
              style={{ fontSize: 14 }}
            >
              {language[lang].confirmationAndWarning.description}
            </p>
            <Divider />

            <div>
              <p className="mb-0">{language[lang].trnxInfoCard.BANK}</p>
              <p className="label fw-bold">{bankNameLang}</p>
            </div>

            <div>
              <p className="mb-0">{language[lang].trnxInfoCard.ACCOUNT_NO}</p>
              <p className="label fw-bold">{accountNumber}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="mb-0">
                  {language[lang].trueMoneyForm.AMOUNT} (฿)
                </p>
                <p className="label fw-bold mb-0">
                  {toLocaleStringFormate(amount)}
                </p>
              </div>
              <ButtonWrapper
                border={true}
                size="middle"
                type="primary"
                bgColor="#051428"
                text={language[lang].confirmationAndWarning.editBtnText}
                icon={<EditOutlined />}
                onClick={() =>
                  navigate(`/${params.id}/auto-payment-method`, {
                    state: { bankName, accountNumber },
                  })
                }
              />
            </div>

            <Divider />
            <p className="warning-text text-center mb-1">
              {language[lang].warningModal.WARNING}
            </p>
            <p className="text-center lh-sm" style={{ fontSize: 14 }}>
              {language[lang].warningModal.FIRST_LINE}
              {language[lang].warningModal.SECOND_LINE}
            </p>

            <div className="w-100">
              <ButtonWrapper
                border={true}
                size="middle"
                type="primary"
                bgColor="#051428"
                height="40px"
                className="w-100 mt-4"
                onClick={() => acceptWarningHandle()}
                loading={isLoading}
                text={language[lang].confirmationAndWarning.iAgreeBtnText}
              />
            </div>
          </div>
        </CardWrapper>
      </MainWrapper>
    </div>
  );
};

export default ConfirmationAndWarningTrueMoney;
